import { createActions, createReducer } from 'reduxsauce'

import DetalhesAdvertenciaFornecedorService from '../../servicos/DetalhesAdvertenciaFornecedorService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesAdvertenciaFornecedorInicio: [],
    buscaDetalhesAdvertenciaFornecedorSucesso: ['detalhesAdvertenciaFornecedor'],
    buscaDetalhesAdvertenciaFornecedorErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDetalhesAdvertenciaFornecedor = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesAdvertenciaFornecedorInicio())
        let serv = new DetalhesAdvertenciaFornecedorService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesAdvertenciaFornecedorSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesAdvertenciaFornecedorErro(error)))
    }
}

const buscaDetalhesAdvertenciaFornecedorInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaDetalhesAdvertenciaFornecedorErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDetalhesAdvertenciaFornecedorSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesAdvertenciaFornecedor, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_ADVERTENCIA_FORNECEDOR_INICIO]: buscaDetalhesAdvertenciaFornecedorInicio,
    [Types.BUSCA_DETALHES_ADVERTENCIA_FORNECEDOR_ERRO]: buscaDetalhesAdvertenciaFornecedorErro,
    [Types.BUSCA_DETALHES_ADVERTENCIA_FORNECEDOR_SUCESSO]: buscaDetalhesAdvertenciaFornecedorSucesso,
})
